import React from 'react';
import { Modal, Space, List, Button, Typography, Tag, Avatar } from 'antd';
import { ThunderboltOutlined, UserOutlined } from '@ant-design/icons';
import { NodeScenarioProposal, LifetreeDetailResponse } from '../../api/models/Lifetree';

const { Text } = Typography;

interface ScenarioProposalsModalProps {
  open: boolean;
  onCancel: () => void;
  scenarioProposals: NodeScenarioProposal[];
  onSelectProposal: (proposal: NodeScenarioProposal) => void;
  lifetreeDetail: LifetreeDetailResponse | null;
  processingProposalIds: Set<string>;
  createdProposalIds: Set<string>;
}

const ScenarioProposalsModal: React.FC<ScenarioProposalsModalProps> = ({
  open,
  onCancel,
  scenarioProposals,
  onSelectProposal,
  lifetreeDetail,
  processingProposalIds,
  createdProposalIds,
}) => {
  return (
    <Modal
      title={
        <Space>
          <ThunderboltOutlined style={{ color: '#faad14' }} />
          <span>Gợi ý Scenario từ AI</span>
        </Space>
      }
      open={open}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <div style={{ marginBottom: 16 }}>
        <Text type="secondary">
          AI đã dựa trên định hướng của Node và các nhân vật hiện có để đề xuất các tình huống sau. 
          Chọn một gợi ý để tiếp tục tạo nội dung chi tiết.
        </Text>
      </div>
      <List
        dataSource={scenarioProposals}
        renderItem={(proposal) => (
          <List.Item
            actions={[
              <Button 
                type={createdProposalIds.has(proposal.id) ? "default" : "primary"}
                onClick={() => onSelectProposal(proposal)}
                loading={processingProposalIds.has(proposal.id)}
                disabled={createdProposalIds.has(proposal.id)}
              >
                {processingProposalIds.has(proposal.id) ? 'Đang tạo...' : createdProposalIds.has(proposal.id) ? 'Đã tạo' : 'Chọn & Tiếp tục'}
              </Button>
            ]}
          >
            <List.Item.Meta
              title={<Text strong>{proposal.title}</Text>}
              description={
                <Space direction="vertical" style={{ width: '100%' }}>
                  <Text>{proposal.summary}</Text>
                  <Space size="small">
                    <Text type="secondary" style={{ fontSize: '12px' }}>Nhân vật:</Text>
                    {proposal.characterStateIds.map(id => {
                      const char = lifetreeDetail?.characters.find(c => c.states.some(s => s.id === id));
                      const state = char?.states.find(s => s.id === id);
                      return (
                        <Tag key={id} color={char?.type === 'main' ? 'gold' : 'blue'}>
                          {state?.name || id}
                        </Tag>
                      );
                    })}
                  </Space>
                </Space>
              }
            />
          </List.Item>
        )}
      />
    </Modal>
  );
};

export default ScenarioProposalsModal;
